import { render, staticRenderFns } from "./CustomerPortalOrders.vue?vue&type=template&id=21d75e3f&scoped=true&"
import script from "./CustomerPortalOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d75e3f",
  null
  
)

export default component.exports